import { dashboardAssignmentsTypes } from "../../types";
const initialState = {
    data: [],
    loading: false,
    error: ""
}
const reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case dashboardAssignmentsTypes.FETCH:
            return { ...state, loading: true }
        case dashboardAssignmentsTypes.SUCCESS:
            return { ...state, data: payload, loading: false, error: "", }
        case dashboardAssignmentsTypes.ERROR:
            return { ...state, loading: false, error: payload }
        case dashboardAssignmentsTypes.RESET:
            return initialState;
        default:
            return state;
    }
}

export default reducer;